<template>
    <o-form v-if="appIsHydrated && dataFetched" :item="item"/>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import OForm from './Form'

    export default {
        components: {
            OForm
        },

        computed: {
            ...mapGetters(['currentProjectId', 'defaultTermsAndConditionsCH', 'appIsHydrated'])
        },

        watch: {
            appIsHydrated() {
                this.item.terms_and_conditions = this.defaultTermsAndConditionsCH
            }
        },

        data() {
            return {
                item: {
                    project_id: null,
                    company_id: null,
                    contact_id: null,
                    approval_deadline: null,
                    deposit_percent: null,
                    terms_and_conditions: null,
                    pay_in_full: false,
                },
                dataFetched: false
            }
        },

        mounted() {
            this.clearProjectServices()

            let projectId = this.$route.query.project_id

            let item = {
                project_id: projectId ? parseInt(projectId) : null,
                company_id: null,
                contact_id: null,
                approval_deadline: null,
                deposit_percent: null,
                terms_and_conditions: null,
                pay_in_full: false
            }

            if (this.appIsHydrated) {
                item.terms_and_conditions = this.defaultTermsAndConditionsCH
            }

            this.item = item

            // if user came from a project page
            // set company_id == project' company_id
            if (item.project_id) {
                this.fetchProjectById(projectId)
                    .then(res => {
                      // console.log(res.data.data.hasOwnProperty('company_billed'), res.data.data.company_billed)
                      if(!res.data.data.hasOwnProperty('company_billed'))
                      {
                        this.item.company_id = 3082
                      }
                      else
                      {
                        this.item.company_id = res.data.data.company_billed
                      }

                      if(!res.data.data.hasOwnProperty('contact_billed'))
                      {
                        this.item.contact_id = 5632
                      }
                      else
                      {
                        this.item.contact_id = res.data.data.contact_billed
                      }

                        this.dataFetched = true
                    })
            } else {
                this.dataFetched = true
            }

        },

        methods: {
            ...mapActions(['fetchProjectById', 'clearProjectServices'])
        }
    }
</script>